import mutations from "./KinematicReplicatorMutations";
import actions from "./KinematicReplicatorActions";
import getters from "./KinematicReplicatorGetters";

export default {
	state: () => (
		{
			SelectedReferenceTurbine: "",
			SelectedTurbines:         [],
			TurbineSearch:            "",
			ConfiguredTurbines:       [],
			ShowAlert:                false,
			SelectAll:                false,
			ModalTexts:               [],
			IsModalOpen:              false,
			ConfirmationDialog:       {
				show:  false,
				title: "",
				text:  ""
			}
		}
	),
	mutations,
	actions,
	getters
};